import { skipToken } from "@tanstack/react-query";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { fontRouter } from "@v2/trpc/routes/font";

export const useUploadedFontOptions = () => {
  const projectId = useCurrentProjectId();
  const { data: fonts = [], isLoading } = fontRouter.getFonts.useQuery(
    projectId ? { projectId } : skipToken,
  );

  const formattedFonts = Array.from(
    new Map(
      fonts
        ?.map((font) => {
          return {
            label: font.name,
            isDefaultActive: false,
            isDisabled: false,
            value: font.name,
            isSelectable: true,
            groupTitle: "From Uploaded",
          };
        })
        .map((font) => [font.value, font]),
    ).values(),
  ).sort((a, b) => a.label.localeCompare(b.label));

  return {
    fontOptions: formattedFonts,
    fonts,
    isLoading,
  };
};
